import './Tab.css';

export const Tabs = ({
  tabs,
  activeTab,
  onChange,
  variant = 'page', // 'page' | 'filter'
  className = '',
}) => {
  return (
    <div className={`tabs tabs--${variant} ${className}`}>
      {tabs.map(tab => {
        const isActive = activeTab === tab.key;

        return (
          <button
            key={tab.key}
            type="button"
            className={`tab-item ${isActive ? 'is-active' : ''}`}
            onClick={() => onChange(tab.key)}
          >
            <span className="tab-label">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};